import NewRelic from "@vp/react-new-relic-browser"
import { Box, Column, GridContainer, H1, Markup, Row } from "@vp/swan"
import { graphql } from "gatsby"
import React from "react"

import Analytics from "../components/Analytics/Analytics"
import StaticPagesLayout from "../components/StaticPagesLayout"

import "../styles/appGlobals.scss"

const PAGE_SECTION = "Legal"

export default (props) => {
  const page = props.pageContext.page
  const availability = props.pageContext.availability
  const trackingConfig = props.pageContext.trackingConfig
  const seoData = props.pageContext.seoData
  const isProdEnvironment = props.pageContext.isProdEnvironment

  return (
    <>
      <NewRelic newRelicApplicationId={process.env.GATSBY_NEW_RELIC_APPLICATION_ID} />
      <Analytics trackingConfig={trackingConfig} locale={page.node_locale} pageName={seoData?.metaTitle} pageSection={PAGE_SECTION} />
      <StaticPagesLayout
        availability={availability}
        pageSeo={seoData}
        isProdEnvironment={isProdEnvironment}
        data={page}
        locale={page.node_locale}
        trackingData={{
          pageName: seoData?.metaTitle,
          pageSection: PAGE_SECTION,
        }}
      >
        <GridContainer as="article">
          <Row>
            <Column span={12}>
              <Box marginBottom={"5"}>
                <H1 marginBottom={"6"}>{page.title}</H1>
              </Box>
            </Column>
          </Row>
          <Row>
            <Column span={12}>
              {page.content ? <Markup dangerouslySetInnerHTML={{ __html: page.content }} /> : null}
              {page.contentExtended ? <Markup dangerouslySetInnerHTML={{ __html: page.contentExtended }} /> : null}
            </Column>
          </Row>
        </GridContainer>
      </StaticPagesLayout>
    </>
  )
}

//needed something to make the warning stop
export const pageQuery = graphql`
  {
    site {
      id
    }
  }
`
